// Articles (ArticlesController) as JSON: `{ json }` on success,
// `{ notFound: true }` for a 404, `{ failed: true }` for anything else.
export async function fetchArticle(path) {
  try {
    const response = await fetch(`${path}.json`, { headers: { Accept: 'application/json' } })
    if (response.status === 404) return { notFound: true }
    if (!response.ok) return { failed: true }
    return { json: await response.json() }
  } catch (error) {
    return { failed: true }
  }
}

export function formatArticleDate(value) {
  const date = new Date(`${value}T00:00:00Z`)
  if (isNaN(date)) return value
  return date.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  })
}
